import { render, staticRenderFns } from "./MedicalContentTemplateNewPopup.vue?vue&type=template&id=94164514&scoped=true&"
import script from "./MedicalContentTemplateNewPopup.vue?vue&type=script&lang=js&"
export * from "./MedicalContentTemplateNewPopup.vue?vue&type=script&lang=js&"
import style0 from "./MedicalContentTemplateNewPopup.vue?vue&type=style&index=0&id=94164514&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94164514",
  null
  
)

export default component.exports